import {DceComponent, DceHTMLElement} from "dce-engine";
import Dce from "dce-engine/lib/decorators/Dce";

interface SliderWithValueProps {
}

@Dce("SliderWithValue")
export default class SliderWithValue extends DceComponent<SliderWithValueProps> {
    private input!: HTMLInputElement;
    private valueEl!: HTMLElement;

    constructor(elem: DceHTMLElement, props: SliderWithValueProps) {
        super(elem, props);

        const input = this.elem.querySelector<HTMLInputElement>('input[type="range"]');
        const valueEl = this.elem.querySelector<HTMLElement>('[data-role="value"]');

        if (!input || !valueEl) {
            console.warn('SliderWithValue: missing input or value element', this.elem);
            return;
        }

        this.input = input;
        this.valueEl = valueEl;

        // 🔹 initial value
        this.update();

        // 🔹 bind event
        this.input.addEventListener('input', () => this.update());
    }

    private update(): void {
        this.valueEl.textContent = this.input.value;


        const value = Number(this.input.value);
        const min = Number(this.input.min);
        const max = Number(this.input.max);

        const percent = ((value - min) / (max - min)) * 99.3;

        this.input.style.setProperty('--progress', percent + '%');

    }
}